import type { ConsumeExchangeTokenResponse } from '@libs/common-types';
import { client } from '../../client';
import { IDENTITY_ENDPOINTS } from '../../constants';

export async function consumeExchangeToken(exchangeToken: string) {
    return await client.identity<ConsumeExchangeTokenResponse>(
        IDENTITY_ENDPOINTS.consumeExchangeToken,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-petm-exchange-token': exchangeToken,
            },
            additionalSuccessCodes: [401],
        }
    );
}
